<div class="flex-column gap">
    @if (todayBirthdays().length) {
        <app-table
            [columns]="todayBirthdaysColumns()"
            [items]="todayBirthdays()"
            [tableTitle]="(prefix + 'titles.birthdays') | translate"
            [translatePrefix]="prefix"
            [hideCheckboxes]="true"
        >
            <ng-template pTemplate="icon" let-data>
                <i class="pi pi-gift text-danger"></i>
            </ng-template>

            <ng-template pTemplate="age" let-data="data">
                <div
                    [ngClass]="{'text-warning': data % 10 !== 0 && data % 5 === 0, 'text-danger': data % 10 === 0}">{{ data }}
                </div>
            </ng-template>
        </app-table>
    }

    @if (todayNameDays().length) {
        <app-table
            [columns]="todayNameDaysColumns()"
            [items]="todayNameDays()"
            [tableTitle]="(prefix + 'titles.nameDays') | translate"
            [translatePrefix]="prefix"
            [hideCheckboxes]="true"
        >
            <ng-template pTemplate="icon" let-data>
                <i class="pi pi-book"></i>
            </ng-template>
        </app-table>
    }

    @if (upcoming().length) {
        <app-table
            [columns]="upcomingColumns()"
            [items]="upcoming()"
            [tableTitle]="(prefix + 'titles.upcoming') | translate"
            [translatePrefix]="prefix"
            [hideCheckboxes]="true"
        >
            <ng-template pTemplate="icon" let-item="item">
                @if (item.type !== 'nameDay') {
                    <i class="pi pi-gift text-danger"></i>
                } @else {
                    <i class="pi pi-book"></i>
                }
            </ng-template>

            <ng-template pTemplate="age" let-item="item" let-data="data">
                @if (item.type !== 'nameDay') {
                    <div
                        [ngClass]="{'text-danger': data % 10 === 0, 'text-warning': data % 10 !== 0 && data % 5 === 0 }">{{ data }}
                    </div>
                }
            </ng-template>

            <ng-template pTemplate="type" let-data="data">
                <div
                    [ngClass]="{'text-danger': data === 'jubilee', 'text-warning': data === 'semiJubilee'}">{{ prefix + 'upcomingType.' + data | translate }}
                </div>
            </ng-template>
        </app-table>
    }

    @if (!todayBirthdays().length && !todayNameDays().length && !upcoming().length) {
        <app-empty-state></app-empty-state>
    }
</div>
